// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"styles_dashboardWrapper__2-joZ","dashboardContent":"styles_dashboardContent__1kJfi"};